import { render, staticRenderFns } from "./itemStageItemTreeEdit.vue?vue&type=template&id=3b55f290"
import script from "./itemStageItemTreeEdit.vue?vue&type=script&lang=js"
export * from "./itemStageItemTreeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports